import { Component, createSignal, For } from 'solid-js'
import { translations } from '~/services/current-document/translations'
import styles from '~/components/translations-list/translations-filter.module.scss'
import { PillOption } from '~/components/toggle-pill/toggle-pill.interfaces'
import Translation from '~/editor/translation/translation'
import { translations as translationsDict } from '~/translations'
import FilterIcon from '~/assets/icons/list.svg'
import DownIcon from '~/assets/icons/chevron-down.svg'

const [filterBy, setFilterBy] = createSignal<PillOption[]>([
  {
    label: translationsDict().editor.translation.filterOptions.all,
    value: 'all',
    checked: true
  },
  {
    label: translationsDict().editor.translation.filterOptions.corrections,
    value: 'corrections',
    checked: false
  },
  {
    label: translationsDict().editor.translation.filterOptions.comments,
    value: 'comments',
    checked: false
  },
  {
    label: translationsDict().editor.translation.filterOptions.onomatopoeias,
    value: 'onomatopoeas',
    checked: false
  }
])

const filterByCorrections = (entry: Translation) => {
  const hasCorrection = entry.versions[entry.versions.length - 1].isCorrection
  return hasCorrection
}

const filterByComments = (entry: Translation) => {
  const hasOpenCommentThread = entry.comments.length > 0 && !entry.comments[entry.comments.length - 1].resolved
  return hasOpenCommentThread
}

const filterByOnomatopoeas = (entry: Translation) => {
  return entry.versions[entry.versions.length - 1].isOnomatopoeia
}

const corrections = () => translations().filter(filterByCorrections)
const comments = () => translations().filter(filterByComments)
const onomatopoeas = () => translations().filter(filterByOnomatopoeas)

const getCountByFilter = (filter: string) => {
  if (filter === 'corrections') return corrections().length
  if (filter === 'comments') return comments().length
  if (filter === 'onomatopoeas') return onomatopoeas().length
  return translations().length
}

const filteredEntries = () => {
  let entries = translations()
  const currentFilter = filterBy().find(option => option.checked)?.value ?? 'all'
  if (currentFilter === 'corrections') entries = corrections()
  if (currentFilter === 'comments') entries = comments()
  if (currentFilter === 'onomatopoeas') entries = onomatopoeas()
  return entries
}

const TranslationsFilter: Component = () => {
  const onChange = (event: Event) => {
    const value = (event.target as HTMLSelectElement).value
    setFilterBy(currentValues => {
      return currentValues.map(option => {
        return {
          ...option,
          checked: option.value === value
        }
      })
    })
  }

  return (
    <>
      <div class={styles.label}>
        <FilterIcon class={styles.icon} />
        <span>{translationsDict().general.actions.display}</span>
      </div>

      <div class={styles.selectContainer}>
        <DownIcon class={styles.downArrow} />

        <select
          class={styles.select}
          onChange={onChange}
        >
          <For each={filterBy()}>
            {(entry) => (
              <option
                value={entry.value}
                selected={entry.checked}
              >
                {entry.label} ({getCountByFilter(entry.value)})
              </option>
            )}
          </For>
        </select>
      </div>
    </>
  )
}

export {
  TranslationsFilter,
  filteredEntries
}